import React, { useEffect, useRef } from "react";
export default function Overlay({
  open,
  onClose,
  title,
  children,
  size = "lg",
}) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const prev = document.activeElement;
    ref.current?.focus();
    return () => {
      document.removeEventListener("keydown", onKey);
      prev?.focus?.();
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title || "Dialog"}
      onClick={(e) => e.target === e.currentTarget && onClose()}
      style={{
        position: "fixed",
        inset: 0,
        background:
          "radial-gradient(80% 100% at 50% 0%, rgba(25,20,15,.75), rgba(25,20,15,.92))",
        backdropFilter: "saturate(115%) blur(6px)",
        zIndex: 50,
        overflow: "auto",
      }}
    >
      <div
        ref={ref}
        tabIndex={-1}
        style={{
          outline: "none",
          minHeight: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: "28px 16px",
        }}
      >
        <div
          className="container"
          style={{
            background: "var(--card)",
            border: "1px solid var(--line)",
            borderRadius: 20,
            boxShadow: "0 20px 60px rgba(0,0,0,.35)",
            padding: 20,
            maxWidth: size === "sm" ? 640 : 1152,
          }}
        >
          <div className="h2" style={{ marginBottom: 12 }}>
            {title}
          </div>
          <div style={{ textAlign: "right", marginBottom: 8 }}>
            <button className="btn" onClick={onClose} aria-label="Close dialog">
              Close
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
